import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import GeneralSettings from "@/components/settings/GeneralSettings";

const Settings = () => {
  const { user, userRole, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/auth");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user || !userRole) {
    return null;
  }

  if (userRole !== "ceo" && userRole !== "general_manager") {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center p-8">
          <p className="text-muted-foreground">Access denied. Only CEO and General Manager can manage settings.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <GeneralSettings />
    </DashboardLayout>
  );
};

export default Settings;
